import React from 'react';
import { init } from './LiveRampManager';

const LiveRamp = ({ children }) => {
  init();
  return <>{children}</>;
};

export default LiveRamp;
